export const BANNER_IMAGE_ID = "BannerImageId";
